<template>
  <header>
      <navigation :pagename="pagename" />
      <h1 class="logo-wrap" alt="栄養の日">
          <a href="./"><Logo /></a>
          <a class="bubble" href="./yobomeshi/movie/">
            <p><span class="brackets"></span>「予防めし」の作り方</p>
            <p>YouTubeで公開中！</p>
            <IconArrow class="icon back" :class="{ 'rotate': 'more' }" />
          </a>
      </h1>
      <div class="top-bar">
          <div class="col">
              <span class="title">栄養の日</span>
              <span class="date">8/4</span>
          </div>
          <div class="col">
              <span class="title">栄養週間</span>
              <span class="date">8/1-7</span>
          </div>
      </div>
      <div class="copyright hideSp">
          <p>Copyright 2020. The Japan Dietetic Association All rights reserved.</p>
      </div>
      <div class="scroll">
        <div class="line">
            <span class="path"></span>
            <span class="circle"></span>
        </div>
        <span>SCROLL</span>
    　</div>
      <a href="./yobomeshi" class="yobomeshi hideSp">
            <span class="circle">
                <morph class="morph"/>
            </span>
            <textyobo class="word"/>
      </a>
      <div class="share-slider" :class="{'active' : shareOpen}">
        <a class="share-btn" @click="sharebar()">
            <span class="share-text">SHARE</span>
            <span class="close-text">CLOSE</span>
            <div class="line"></div>
        </a>
        <div class="share-cover" v-if="shareOpen" @click="sharebar()"></div>
        <div class="share-body">
            <iframe 
                src="https://www.facebook.com/plugins/like.php?href=https%3A%2F%2Fwww.nutas.jp%2F84%2F&width=72&layout=box_count&action=like&size=small&share=false&height=65&appId=1144307432612810" 
                class="fb like btn" width="80" height="39" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true" allow="encrypted-media">
            </iframe>
            <a href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fwww.nutas.jp%2F84%2F&amp;src=sdkpreparse" target="_blank">
              <img src="@/assets/share/fb.svg" alt="fb-Share">
            </a>
            <a href="http://twitter.com/share?text=（公社）日本栄養士会は、8月4日を「栄養の日」、8月1日から7日を「栄養週間」と制定しました。2020年は、管理栄養士・栄養士から国民に向けて、新しい食生活とライフスタイルの提案、その取り組みとして「予防めし」を発信しますhttps://www.nutas.jp/84/" 
              target="_blank">
              <img src="@/assets/share/twitter.svg" alt="tw-share">
            </a>
            <a href=" https://social-plugins.line.me/lineit/share?url=https://nutas.jp/84/" 
              target="_blank">
              <img src="@/assets/share/line.svg" alt="tw-share">
            </a>
            <div class="bg-texture"></div>
        </div>
      </div>
  </header>
</template>

<script>
import navigation from '@/components/_navigation.vue'
import Logo from '@/assets/logo.svg?inline'
import textyobo from '@/assets/txt-yobo.svg?inline'
import morph from '@/assets/morph-circle1.svg?inline'
import IconArrow from '@/assets/icon-arrow.svg?inline'

export default {
  name: 'Header',
  props: {
    pagename: String
  },
  components:{
      navigation,
      Logo,
      textyobo,
      morph,
      IconArrow
  },
  data(){
      return{
          shareOpen: false,
      }
  },
  methods:{
      sharebar(){
          if(this.shareOpen == false){
            this.shareOpen = true
          }
          else{
            this.shareOpen = false
          }
      },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
header{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 2;
        #menu{
            width: 100vw;
            height: 100vh;
            overflow: hidden;
            background: transparent;
            .cover{
                display: block;
                position: absolute;
                width: 100%;
                height: 100%;
            }
        }
        .top-bar{
            position: absolute;
            top: $pc-gutter;
            right: $pc-gutter;
            display: flex;
            flex-flow: row nowrap;
            margin-right: 60px;
            @media #{$maxM}{
                top: calc(100vh - 14px - 1.875em);
                right: inherit;
                left: $sp-gutter;
                flex-flow: row nowrap;
                justify-content: flex-start;
                align-items: flex-end;
            }
                .col{
                    display: flex;
                    justify-content: flex-start;
                    letter-spacing: 0.1em;
                    &:first-child{
                        margin-right: 36px;
                        @media #{$maxM}{
                            margin-right: 24px;
                        }
                    }
                    span{
                        white-space: nowrap;
                    }
                    .title{
                        font-size: 0.875em;
                        line-height: 1.475em;
                        margin-right: 5px;
                    }
                    .date{
                        font-family: $rosewood;
                        color: $red;
                        font-size: 1.875em;
                        line-height: 1em;
                        @media #{$IE}{
                            margin-top: -5px;
                        }
                    }
                }
        }

        .logo-wrap{
            position: absolute;
            top: $pc-gutter;
            left: $pc-gutter;
            width: 140px;
            @media #{$maxM}{
                top: $sp-gutter;
                left: $sp-gutter;
                width: 100.64px;
            }
            @media #{$IE}{
                height: 62px;
            }
            .bubble {
              background-image: url('~@/assets/bubble.png');
              background-size: contain;
              background-repeat: no-repeat;
              width: 234px;
              height: 77px;
              font-size: 14px;
              letter-spacing: 0.1em;
              display: flex;
              justify-content: center;
              align-items: center;
              flex-direction: column;
              padding-top: 8px;
              position: absolute;
              transition: 0.3s;
              bottom: -100px;
              left: 0;
              cursor: pointer;
              @media #{$IE}{
                  padding-top: 11px;
              }
              @media #{$maxM}{
                background-image: url('~@/assets/bubble_sp.png');
                width: 186px;
                height: 54px;
                font-size: 12px;
                padding-top: 0px;
                top: 5px;
                bottom: auto;
                left: auto;
                right: -192px;
                @media #{$IE}{
                    padding-top: 4px;
                }
              }
              p {
                margin-right: 10px;
                @media #{$maxM}{
                  margin-right: 0px;
                }
              }
              .brackets {
                margin-left: -10px;
              }
              .icon{
                width: 7.63px;
                height: 12.43px;
                position: absolute;
                top: 53.5%;
                right: 25px;
                transform: translate(-50%, -50%);
                transition: 0.3s;
                path{
                  fill: #000 !important;
                }
                @media #{$maxM}{
                  width: 5.02px;
                  height: 8.18px;
                  top: 50%;
                  right: 18px;
                }
              }
              &:hover {
                @media #{$minM}{
                  opacity: 0.8;
                  .icon {
                    right: 20px;
                  }
                }
              }
            }
        }
        .scroll{
            position: fixed;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-flow: column;
            left: calc(#{$pc-gutter} - 0.5em);
            bottom: 30px;
            width: auto;
            @media #{$maxM}{
                left: unset;
                right: $sp-gutter;
                bottom: unset;
                top: calc(100vh - 14px - 85px);
                position: absolute;
                @media #{$IE}{
                  left: auto;
                  bottom: auto;
                }
            }
            span{
                writing-mode: vertical-rl;
                transform: rotate(180deg);
                font-size: 0.813em;
                letter-spacing: 0.05em;
                font-weight: 600;
                @media #{$maxM}{
                    font-size: 0.714em;
                }
            }
            .line{
                display: flex;
                justify-content: center;
                align-items: center;
                width: 1em;
                height: 36px;
                position: relative;
                margin-bottom: 5.5px;
                @media #{$maxM}{
                    width: 6px;
                }
                .path{
                    width: 1px;
                    height: 100%;
                    background: $black;
                    border-radius: 2px;
                } 
                .circle{
                    width: 6px;
                    height: 6px;
                    background: $black;
                    border-radius: 100%;
                    position: absolute;
                    left: 5.5px;
                    top: 2px;
                    animation-name: scroll;
                    animation-duration: 2s;
                    animation-iteration-count: infinite;
                    @media #{$maxM}{
                        left: 0;
                    }
                    @keyframes scroll {
                        0%{ top: 2px; }
                        70%{ top: 30px; }
                        100%{ top: 2px; }
                    }
                }
            }
        }
        .yobomeshi{
            position: absolute;
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 172px;
            height: 20px;
            top: calc(100vh - #{$pc-gutter} - 20px); 
            right: $pc-gutter;
                svg{
                    height: 11.9px;
                    width: auto;
                }
                svg.morph{
                    height: 20px;
                    transition: 0.4s;
                    @media #{$IE}{
                      width: 20px;
                    }
                }
            &:hover{
                opacity: 0.7;
                    svg.morph{
                        transform: scale(1.2);
                    }
            }
        }
        .share-cover{
            position: fixed;
            width: 100vw;
            height: 100vh;
            top: 0;
            left: 0;
            background: transparent;
        }
        .share-slider{
            position: fixed;
            height: 100vh;
            width: auto;
            display: flex;
            flex-flow: row nowrap;
            justify-content: center;
            align-items: center;
            right: 0;
            top: 0;
            .share-text {
              opacity: 1;
              transition: 0.8s;
            }
            .close-text {
              opacity: 0;
              transition: 0s;
            }
            &.active{
                .share-btn{
                    transform: translateX(-130px);
                    @media #{$maxM}{
                        transform: translateX(-110px);
                    }
                }
                .share-body{
                    right: 0;
                }
                .share-text {
                  opacity: 0;
                  transition: 0s;
                }
                .close-text {
                  opacity: 1;
                  transition: 0.8s;
                }
            }
        }
        .share-body{
            width: calc(215px - 116px - 30px);
            height: 100%;
            background: $white;
            display: flex;
            flex-flow: column;
            align-items: center;
            justify-content: center;
            padding: 0 30px 0 116px;
            position: absolute;
            top: 0;
            right: -215px;
            transition: 0.4s;
            z-index: 1;
            box-shadow: 0px 3px 6px 0px rgba(0,0,0,0.16);;
            @media #{$maxM}{
               padding: 0 20px 0 74px;
               width:calc(162px - 74px - 20px);
            }
                a{
                    margin-top: 10px;
                    width: 80px;
                }
                .bg-texture{
                    position: absolute;
                    top: 0;
                    left: 0;
                }
        }
        .share-btn{
            display: flex;
            flex-flow: row nowrap;
            justify-content: flex-end;
            align-items: center;
            z-index: 4;
            font-size: 0.813em;
            letter-spacing: 0;
            transition: 0.4s;
            width: auto;
            height: 52px;
            font-size: 0.6875em;
            @media #{$maxM}{
                font-size: 0.714em;
                writing-mode: vertical-lr;
                justify-content: center;
                flex-flow: column;
                height: 36px;
                font-size: 10px;
            }
                .line{
                    display: block;
                    width: 16px;
                    height: 1px;
                    background: $black;
                    margin-left: 4px;
                    margin-bottom: 1px;
                    @media #{$IE}{
                        height: auto;
                        border-bottom: 1px solid black;
                    }
                    @media #{$maxM}{
                        
                    }
                }
        }
        
        .copyright{
            position: absolute;
            top: 50vh;
            left: calc(#{$pc-gutter} - 1em);
            font-family: $roboto;
            font-weight: 400;
            font-size: 10px;
            letter-spacing: 0.05em;
            transform: rotate(180deg) translateY(50%);
            p{
                writing-mode: vertical-rl;
            }
            @media screen and (max-height: 670px){
                display: none;
            }
            @media #{$IE}{
              position: fixed;
              left: calc(30px - 0.5em);
              transform: rotate(270deg) translate(-50%, 0);
              transform-origin: left;
              p {
                writing-mode: lr-tb;
              }
            }
        }
}

</style>
